// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ie-0";